import React from "react";
import { FiGift, FiCamera, FiTruck, FiMapPin } from "react-icons/fi";

const servicesData = [
  { title: "Decor & theming", description: "Balloon setups, backdrops, and full theme styling matched to the guest of honor.", Icon: FiGift },
  { title: "Cakes & catering", description: "From a single custom cake to a full catering spread, sourced from vetted partners.", Icon: FiMapPin },
  { title: "Photography", description: "Candid coverage so the day is remembered properly, when you want it covered.", Icon: FiCamera },
  { title: "Delivered on schedule", description: "Everything you order arrives ready for the celebration — no separate pickups or coordination.", Icon: FiTruck },
];

const Services = () => {
  return (
    <section className="bg-paper py-16 lg:py-24">
      <div className="max-w-content mx-auto px-6 lg:px-10">
        <div className="max-w-prose">
          <h2 className="text-3xl font-bold text-brand sm:text-4xl">
            Everything a birthday needs, coordinated in one place
          </h2>
          <p className="mt-4 text-muted">
            Pick what you need — we assign verified partners for each part
            of the event and manage them as one team.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-2 lg:grid-cols-4">
          {servicesData.map((service) => (
            <div key={service.title} className="border-t-2 border-action pt-6">
              <service.Icon className="text-action" size={22} />
              <h3 className="mt-4 text-lg font-semibold text-charcoal">{service.title}</h3>
              <p className="mt-2 text-sm text-muted">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
